export const shopifyProductId = process.env.SHOPIFY_PRODUCT_ID;